import { createAction } from 'redux-actions';

export const successImportItemQty = createAction(
  'INVENTORY_ITEM_QTY_SUCCESS_IMPORT'
);

export const failedImportItemQty = createAction(
  'INVENTORY_ITEM_QTY_FAILED_IMPORT'
);

export const ignoredImportItemQty = createAction(
  'INVENTORY_ITEM_QTY_IGNORED_IMPORT'
);

export const clearImportItemsQty = createAction(
  'INVENTORY_ITEMS_QTY_CLEAR_IMPORT'
);
